import { failed } from "../../components/common/Toastify"

export const onError = (error) => {
    failed(error?.response?.data?.message || error?.response?.data?.error || error.message)
}